// extracted by mini-css-extract-plugin
export default {"payments":"Gc-z","header":"Hc-z","adjustMarginAndPaddingNewDesign":"Ic-z"};